module.exports = __webpack_public_path__ + "static/media/bs.605b854e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bs.svg
// module id = 73
// module chunks = 0